import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { IconRemainingPekkaset } from "../../common/icons";
import { localized } from "../../common/utils";


export function PersonalRemainingPekkasHours({ personalDashboardData }) {
  const { t } = useTranslation();

  const remaining = personalDashboardData?.pekkanenHours ? localized.numberFormat.format(personalDashboardData.pekkanenHours) : "-";

  return (
    <>
      <h4 style={{ color: "var(--heeros-blue)" }}>{t("RemainingPekkasHours", "Pekkassaldo")}</h4>
      <Row className="text-center mt-4-5">
        <Col>
          <IconRemainingPekkaset />
          <div className="vacation-label">{t("RemainingPekkasHours", "Pekkasia jäljellä")}</div>
          <h2 className="vacation-value">{remaining}</h2>
        </Col>
      </Row>
    </> );
}
